import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { primary_theme_color, secondary_theme_color } from '../../../../constants/constants';
import { useTranslation } from 'react-i18next';
import { IconButton }  from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material'
import PluginSnackbar from '../Snackbar';
const AfterCloseFeedbackBody = ({ open, handleClose, data }) => {
    const { i18n, t } = useTranslation();
    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    return (
        <PluginSnackbar open={open} message={t('general.closeFeedbackSuccess.level')} onClose={handleClose} />
        // <Snackbar
        //     open={open}
        //     autoHideDuration={4000}
        //     onClose={handleClose}
        //     message={t('general.closeFeedbackSuccess.level')}
        //     style={{ backgroundColor: primary_theme_color, color: secondary_theme_color }}
        //     action={action}
        // />
    );
};

export default AfterCloseFeedbackBody;
